/* Eleganz Nexus: Linien, Kacheln und Text blenden per CSS ab Seitenstart ein
   (kein Warten auf dieses defer-Script); danach („is-settled“) laufen die
   Lichtimpulse und die Hover-Übergänge ohne Einblend-Verzögerung.
   Beim Hover über eine Kachel leuchtet ihre Verbindungslinie auf, die Kachel
   neigt sich zum Zeiger und ein Lichtreflex folgt ihm (wie die Glas-Karten
   der Eleganz Collections). Auf Touch-Geräten zeigt der Mittelpunkt beim
   ersten Scrollen kurz seinen Linktext. Ohne Script bleibt alles sichtbar. */
(function () {
  'use strict';
  var SETTLE_MS = 2600;
  function init(root) {
    if (root.dataset.nexusReady === 'true') return;
    root.dataset.nexusReady = 'true';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    // Das Einblenden läuft per CSS ab Seitenstart; das Script kann auf langsamen
    // Geräten deutlich später kommen. "is-settled" (Impulse, Hover ohne Verzögerung)
    // daher relativ zum Seitenstart setzen, nicht zum Script-Start.
    root.classList.add('is-active');
    var activeAt = Date.now() - performance.now();
    setTimeout(function () { root.classList.add('is-settled'); },
      reduced ? 0 : Math.max(0, SETTLE_MS - performance.now()));
    function hot(node, on) {
      var path = root.querySelector('.ej-nexus__path[data-k="' + node.getAttribute('data-k') + '"]');
      if (path) path.classList.toggle('is-hot', on);
    }
    root.querySelectorAll('a.ej-nexus__node').forEach(function (node) {
      node.addEventListener('mouseenter', function () { hot(node, true); });
      node.addEventListener('mouseleave', function () { hot(node, false); });
      node.addEventListener('focus', function () { hot(node, true); });
      node.addEventListener('blur', function () { hot(node, false); });
    });

    if (fine && !reduced) {
      root.querySelectorAll('a.ej-nexus__node:not(.ej-nexus__node--lg)').forEach(function (node) {
        var frame = 0, px = 0.5, py = 0.5;
        function paint() {
          frame = 0;
          node.style.setProperty('--rx', ((0.5 - py) * 9).toFixed(2) + 'deg');
          node.style.setProperty('--ry', ((px - 0.5) * 11).toFixed(2) + 'deg');
          node.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
          node.style.setProperty('--my', (py * 100).toFixed(1) + '%');
        }
        node.addEventListener('pointerenter', function () { node.classList.add('is-tracking'); });
        node.addEventListener('pointermove', function (e) {
          var r = node.getBoundingClientRect();
          px = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
          py = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
          if (!frame) frame = requestAnimationFrame(paint);
        });
        node.addEventListener('pointerleave', function () {
          node.classList.remove('is-tracking');
          if (frame) { cancelAnimationFrame(frame); frame = 0; }
          node.style.setProperty('--rx', '0deg');
          node.style.setProperty('--ry', '0deg');
        });
      });
    }

    // Touch: kurzer „Hover“ des Mittelpunkts, sobald von ganz oben aus gescrollt
    // wird; wieder scharf, wenn die Seite zurück oben ist.
    var hub = root.querySelector('a.ej-nexus__node--lg');
    if (hub && !fine) {
      var armed = window.scrollY < 40, pending = false, timer = 0;
      var inView = function () {
        var r = hub.getBoundingClientRect();
        return r.bottom > 0 && r.top < window.innerHeight - r.height * 0.4;
      };
      var peek = function () {
        if (!root.classList.contains('is-active') || !inView()) return false;
        var wait = Math.max(0, activeAt + 1100 - Date.now());
        clearTimeout(timer);
        timer = setTimeout(function () {
          root.classList.add('is-peek');
          timer = setTimeout(function () { root.classList.remove('is-peek'); }, 1800);
        }, wait);
        return true;
      };
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (y < 40) { armed = true; pending = false; return; }
        if (armed) { armed = false; pending = true; }
        if (pending && peek()) pending = false;
      }, { passive: true });
    }
  }
  function boot() { document.querySelectorAll('[data-ej-nexus]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-ej-nexus]');
    if (el) { el.dataset.nexusReady = ''; init(el); }
  });
})();
